export default __webpack_public_path__ + "87461a298b96cc31307c535bac0b8e8a.png";